// extracted by mini-css-extract-plugin
export default {"select":"TitlePatientNameSelect_select__Sl9Et"};